/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */
// Setup variables needed for the app to run.
window.__CLIENT__ = true;
window.__SERVER__ = false;
window.__DEVELOPMENT__ = false;
window.__DEVTOOLS__ = false;
window.__PROFILING__ = false;

import React from 'react';
import ReactDOM from 'react-dom';
import { HeadProvider } from 'react-head';
import createStore from './redux/create';
import ApiClient from '../shared/ApiClient';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './pages/App/App';

const client = new ApiClient();

const dest = document.getElementById('content');
const store = createStore(client, window.__data);
ReactDOM.render(
    <Provider key="provider" store={store}>
        <BrowserRouter>
            <HeadProvider>
                <App />
            </HeadProvider>
        </BrowserRouter>
    </Provider>,
    dest,
    process.env.FINN_ENV !== 'prod' &&
        (() => {
            window.INITIAL_RENDER_COMPLETE = true;
        })
);

if (process.env.NODE_ENV !== 'production') {
    window.React = React; // enable debugger

    if (
        !dest ||
        !dest.firstChild ||
        !dest.firstChild.attributes ||
        !dest.firstChild.attributes['data-react-checksum']
    ) {
        setTimeout(() => {
            throw new Error(
                'Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.'
            );
        });
    }
}
